import InsightsList from './InsightsList'

export default InsightsList
